import type { OptionProps, Option as TOption } from '@usealloy/component-library';
import { Tooltip } from '@usealloy/component-library';
import React from 'react';

import type { ActionOptionMeta } from '../types';
import Option from './Option';


interface Props<T> extends OptionProps<T, false> { }

export default function DisabledOptionWithTooltip<T extends TOption<ActionOptionMeta>>(
  props: Props<T>,
) {
  const { data: { meta: { copy = {} } = {} } = {}, isDisabled } = props;

  if (isDisabled && copy.disabled?.length) {
    return (
      <Tooltip content={copy.disabled} delayDuration={0} side="right">
        <div><Option<T> {...props} /></div>
      </Tooltip>
    );
  }

  return <Option<T> {...props} />;
}
